<!-- @format -->

<button
	hmf-button
	sharedComponentsLongpress
	class="carousel-button"
	[style.visibility]="(previous() && showLeftArrow()) || (!previous() && showRightArrow()) ? 'visible' : 'hidden'"
	[attr.title]="ariaLabel()"
	[label]="ariaLabel()"
	[variant]="'secondary'"
	[size]="size()"
	[shape]="'circular'"
	[icon]="'chevron-' + (previous() ? 'left-outline' : 'right-outline')"
	[iconSize]="iconSize()"
	(mouseLongPress)="onClick()"
	(click)="onClick()">
</button>
